'use strict';

var formFields = {
    init : function() {
        //WCAG Global forms - Removing aria attribute from div - This is coming globally from Jquery Validate plugin
        $('form').find("div.form-row").removeAttr("aria-required");
        //WCAG End
    },
}

module.exports = formFields;